import React, {Component} from 'react'
import PropTypes from 'prop-types'

import ContrassegnoLogo from '../../../assets/logo-contrassegno.png'
import DownloadLogo from '../../../assets/download.png'
import {NavLink} from 'react-router-dom'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import moment from 'moment'
import UserInfoBox from '../UserInfoBox/UserInfoBox'
import Threesome from '../../../assets/triangolo.png'

const TextUser = (props) => <div className={props.bold ? "text-bold-user" : "text-regular-user"}>{props.children}</div>

export default class UserAreaMarks extends Component {
  static propTypes = {
    onOpenRenewMarkModal: PropTypes.func.isRequired,
    onCloseRenewMarkModal: PropTypes.func.isRequired,
    renewingMark: PropTypes.object
  }

  constructor (props) {
    super(props)
  }

  render () {
    const {
      onOpenRenewMarkModal,
      onCloseRenewMarkModal
    } = this.props
    if (this.isUserBelongsToCategory(1)) {
      return (<div className="text-danger">Errore! Questo utente non può possedere contrassegni</div>)
    }
    /* <div className={'row '} style={{pointerEvents: !this.props.userAdjustment.payed ? 'none' : 'auto'}}> */
    return (
      <div className={'row '}>
        {/* <div className="col-md-2">
                 {this.props.user.marks && <div className="square-box">
                 <span className="glyphicon glyphicon-tag glyphicon-lg">{}</span>
                 </div>}
                 </div> */}
        <div className="col-md-7">
          <div className="panel panel-default panel-border-login">
            <h2 className="login-title">CONTRASSEGNI</h2>
            <div className="panel-body">
              <div className="col-md-3"><img className="user-admin-logo" src={ContrassegnoLogo} /></div>
              <div className="col-md-9">
                {/* <div className={'user-card-btn-2'}>
                  <div className="row" style={{display: 'flex'}}>
                    <div className="col-md-10 text-left col-personalized-user">
                      <strong>SCARICA MODULISTICA</strong>
                    </div>
                    <NavLink className={'user-card-btn3'} to="/"><strong>#</strong></NavLink>
                  </div>
                </div> */}
                <div className="user-card-btn-1">
                  <div className="row" style={{display: 'flex'}}>
                    <div className="col-md-10 text-left col-personalized-user">
                      <strong>RICHIEDI CONTRASSEGNO </strong>
                    </div>
                    <a className="user-card-btn3" href="javascript:void(0);"><strong>+</strong></a>
                    {/*<NavLink className={'user-card-btn3'} to="/user-area/marks/create"><strong>+</strong></NavLink>*/}
                  </div>
                </div>

                {this.props.user.marks ? this.props.user.marks.map(item => {
                  const today = moment()
                  let startDateM = moment(item.startDate)
                  let endDateM = moment(item.endDate)
                  let isTemporary = endDateM.diff(startDateM, 'days') === 60 || endDateM.diff(startDateM, 'days') === 59
                  const isExpired = today.diff(endDateM, 'days') > 0
                  return (<div key={item.id}>
                    {item.active && isTemporary && <div className="user-card">
                      <div className="user-card-head-t">
                        <h5 className="user-card-title">CONTRASSEGNO: <strong>TEMPORANEO{' '}</strong>
                          <OverlayTrigger placement="top" overlay={<Tooltip>Questo è il tuo contrassegno <strong>TEMPORANEO</strong> con <strong>60 giorni di validità</strong>.<br />Clicca su "Contrassegno" per scaricarlo, stampalo ed esibiscilo sul parabrezza dell{"' "}auto per utilizzarlo.</Tooltip>}>
                            <span className="question-icon glyphicon glyphicon-question-sign">{}</span>
                          </OverlayTrigger></h5>
                      </div>
                      <div className="user-card-body">
                        <div className="row">
                          <div style={{padding: 0}} className="col-md-6">
                            <strong>{item.MarkType.name + ' ' + item.Category.label.toUpperCase()}</strong>{item.ceased && <span style={{color: 'red', marginLeft: 10}}> CESSATO</span>}
                          </div>
                          <div style={{padding: 0}} className="col-md-6 text-right">
                            ZON{item.MarkType.Areas.length > 1 ? 'E' : 'A'} <strong>{item.MarkType.Areas.map(item => item.code + ' ')}</strong>
                          </div>
                          <div style={{padding: 0, marginBottom: 5, marginTop: 5}} className="col-md-12">
                            <span>NUM. IDENTIFICATIVO: <strong>{item.id}</strong></span><br />
                            {item.fatherMark && <span>DERIVATO DA CONTRASSEGNO N.: <strong>{item.fatherMark}</strong></span>}
                          </div>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <span>TARG{item.Vehicles.length > 1 ? 'HE' : 'A'}: <strong>{item.Vehicles.map(item => item.plate_number + ' ')}</strong></span>
                          </div>
                        </div>
                      </div>
                      <div className="border-div">{}</div>

                      <div className="user-card-footer">
                        <div className="row">
                          <div style={{padding: 0, marginBottom: 5, marginTop: 5}} className="col-md-12">
                            {this.props.user.marks && <span>EMMESSO IL: <strong>{moment(item.issudeDate).format('L')}</strong></span>}
                          </div>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            VALIDO DAL <strong>{moment(item.startDate).format('L')}</strong> AL <strong>{moment(item.endDate).format('L')}</strong>
                          </div>

                          {this.props.user.userConfirmed && <div className="button-download">
                            <div className="col-md-6 col-btn-display">
                              <OverlayTrigger placement="top" overlay={<Tooltip>Questo è il tuo <strong>Contrassegno Temporaneo</strong>.<br /> Scaricalo, stampalo ed esibiscilo sul parabrezza dell{"' "}auto</Tooltip>}>
                                <a onClick={() => this.props.onDownloadMark(item)} className="btn-download-user">
                                  <img className="download-logo" style={{width: 20, height: 17, paddingBottom: 1}} src={DownloadLogo}>{}</img> CONTRASSEGNO</a>
                              </OverlayTrigger>
                            </div>
                            <div className="col-md-6 col-btn-display">
                              <OverlayTrigger placement="top" overlay={<Tooltip>Questo è il <strong>Modulo di Rilascio</strong>.<br /> Scaricalo, stampalo, compilalo e portalo con te quando andrai a ritirare il tuo contrassegno definitivo</Tooltip>}>
                                <a onClick={() => this.props.onDownloadMarkRelease(item)} className="btn-download-user">
                                  <img className="download-logo" style={{width: 20, height: 17, paddingBottom: 1}} src={DownloadLogo}>{}</img> ACCETTAZIONE</a>
                              </OverlayTrigger>
                            </div>
                          </div>}

                          {!this.props.user.userConfirmed && <div className="button-download">
                            <a disabled className="btn btn-info-user"><i className="glyphicon glyphicon-download">{}</i> Contrassegno</a>
                            <a disabled className="btn btn-info-user"><i className="glyphicon glyphicon-download">{}</i> Accettazione</a>
                          </div>}
                        </div>
                      </div>
                    </div>}

                    {(item.active && !isTemporary && ((item.paid && item.price > 0) || (item.price === 0 || !item.price))) && <div className="user-card">
                      {(!item.ceased && !isExpired) && <div className="user-card-head-a">
                        <h5 className="user-card-title">CONTRASSEGNO: <strong>ATTIVO{' '}</strong>
                          <OverlayTrigger placement="top" overlay={<Tooltip>Questo è un contrassegno attivo ed utilizzabile.</Tooltip>}>
                            <span className="question-icon glyphicon glyphicon-question-sign">{}</span>
                          </OverlayTrigger>
                        </h5>
                      </div>}
                      {(!item.ceased && isExpired) && <div className="user-card-head-c">
                        <div className="user-card-head">
                          <h5 className="user-card-title">CONTRASSEGNO: <strong>SCADUTO{' '}</strong>
                            <OverlayTrigger placement="top" overlay={<Tooltip>Questo è un contrassegno scaduto, non è ancora stato cessato ma non è più utilizzabile.</Tooltip>}>
                              <span className="question-icon glyphicon glyphicon-question-sign">{}</span>
                            </OverlayTrigger>
                          </h5>
                        </div>
                      </div>}
                      {item.ceased && <div className="user-card-head-c">
                        <div className="user-card-head">
                          <h5 className="user-card-title">CONTRASSEGNO: <strong>CESSATO{' '}</strong>
                            <OverlayTrigger placement="top" overlay={<Tooltip>Questo è un contrassegno cessato, non è più utilizzabile.</Tooltip>}>
                              <span className="question-icon glyphicon glyphicon-question-sign">{}</span>
                            </OverlayTrigger>
                          </h5>
                        </div>
                      </div>}
                      <div className="user-card-body">
                        <div className="row">
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-6">
                            <strong>{item.MarkType.name + ' ' + item.Category.label.toUpperCase()}</strong>
                          </div>
                          <div style={{padding: 0}} className="col-md-6 text-right">
                            ZON{item.MarkType.Areas.length > 1 ? 'E' : 'A'} <strong>{item.MarkType.Areas.map(item => item.code + ' ')}</strong>
                          </div>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <span>NUM. IDENTIFICATIVO: <strong>{item.id}</strong></span><br />
                            {item.fatherMark && <span>DERIVATO DA CONTRASSEGNO N.: <strong>{item.fatherMark}</strong></span>}
                          </div>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <span>TARG{item.Vehicles.length > 1 ? 'HE' : 'A'}: <strong>{item.Vehicles.map(item => item.plate_number + ' ')}</strong></span>
                          </div>
                        </div>
                      </div>
                      <div className="border-div">{}</div>
                      <div className="user-card-footer">
                        <div className="row">
                          <div style={{padding: 0, marginBottom: 5, marginTop: 5}} className="col-md-12">
                            {this.props.user.marks && <span>EMESSO IL: <strong>{moment(item.issudeDate).format('L')}</strong></span>}
                          </div>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <span>VALIDO DAL <strong>{moment(item.startDate).format('L')}</strong> AL <strong>{moment(item.endDate).format('L')}</strong></span>
                          </div>
                        </div>
                        {(!item.ceased && item.active && ((item.price > 0 && item.paid) || (item.price === 0 || !item.price))) && <div className="row">
                          <div style={{padding: 0, marginBottom: 5, marginTop: 5}} className="col-md-12">
                            {
                              /*
                              <div className="col-md-6 col-btn-display">
                                <a onClick={() => this.props.onDownloadMark(item)} className="btn-download-user">
                                  <img className="download-logo" style={{width: 20, height: 17, paddingBottom: 1, marginRight: 10}} src={DownloadLogo}>{}</img> CONTRASSEGNO</a>
                              </div>
                              */
                            }
                            {(item.MarkOrder && item.MarkOrder.Order && item.MarkOrder.Order.Receipt) && (
                              <div className="col-md-12 col-btn-display">
                                <a onClick={() => this.props.onMarkReceiptDownload(item.id)} className="btn-download-user" style={{textAlign: 'center'}}>
                                  <img className="download-logo" style={{width: 20, height: 17, paddingBottom: 1, marginRight: 10}} src={DownloadLogo}>{}</img> RICEVUTA</a>
                              </div>
                            )}


                            {/*(item.status === 'ACTIVE_EDITABLE' || item.status === 'PENDING_EDITABLE') && (
                              <div className="col-md-6 col-btn-display">
                                <NavLink to={`/user-area/marks/edit/${item.id}`} className="btn-download-user">MODIFICA</NavLink>
                              </div>
                            )*/}
                            {/* (moment(item.endDate).startOf('day').diff(moment().startOf('day'), 'days') <= 3 && !item.renewed) && (
                              <div className="col-md-6 col-btn-display">
                                <a onClick={() => onOpenRenewMarkModal(item)} className="btn-download-user">
                                  RINNOVA
                                </a>
                              </div>
                            ) */}
                          </div>
                        </div>}
                      </div>
                    </div>}

                    {(item.active && !isTemporary && (!item.paid && item.price > 0)) && <div className="user-card user-card-at">
                      <div className="user-card-head-c">
                        <div className="user-card-title">
                          CONTRASSEGNO: <strong>IN ATTESA DI PAGAMENTO{' '}</strong>
                          <OverlayTrigger placement="top" overlay={<Tooltip>Questo contrassegno si attiverà una volta pagato il saldo.</Tooltip>}>
                            <span className="question-icon glyphicon glyphicon-question-sign">{}</span>
                          </OverlayTrigger>
                        </div>
                      </div>
                      <div className="user-card-body">
                        <div className="row">
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-6">
                            <span><strong>{item.MarkType.name + ' ' + item.Category.label.toUpperCase()}</strong>{item.ceased && <span style={{color: 'red', marginLeft: 10}}> CESSATO</span>}</span>
                          </div>
                          <div style={{padding: 0}} className="col-md-6 text-right">
                            <span>ZON{item.MarkType.Areas.length > 1 ? 'E' : 'A'}: <strong>{item.MarkType.Areas.map(item => item.code + ' ')}</strong></span>
                          </div>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <span>NUM. IDENTIFICATIVO: <strong>{item.id}</strong></span><br />
                            {item.fatherMark && <span>DERIVATO DA CONTRASSEGNO N.: <strong>{item.fatherMark}</strong></span>}
                          </div>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <span>TARG{item.Vehicles.length > 1 ? 'HE' : 'A'}: <strong>{item.Vehicles.map(item => item.plate_number + ' ')}</strong></span>
                          </div>
                        </div>
                      </div>
                      <div className="border-div">{}</div>
                      <div className="user-card-footer">
                        <div className="row">
                          <div style={{padding: 0, marginBottom: 5, marginTop: 5}} className="col-md-12">
                            {this.props.user.marks && <span>EMESSO IL: <strong>{moment(item.issudeDate).format('L')}</strong></span>}
                          </div>
                        </div>
                        <div className="row">
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <span>PREZZO: <strong>€ {Number(item.price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</strong></span>
                          </div>
                        </div>
                        <div className="row">
                          <NavLink to={'/user-area/pay/mark/' + item.id} className="btn-download-user">
                            PAGA CONTRASSEGNO
                          </NavLink>
                        </div>
                      </div>
                    </div>}

                    {!item.active && <div className="user-card user-card-at">
                      <div className="user-card-head-a">
                        <div className="user-card-title">
                          CONTRASSEGNO: <strong>IN ATTESA DI APPROVAZIONE{' '}</strong>
                          <OverlayTrigger placement="top" overlay={<Tooltip>Questo sarà il tuo contrassegno definitivo. Al momento dell'approvazione ti arriverà una e-mail all'indirizzo fornito.</Tooltip>}>
                            <span className="question-icon glyphicon glyphicon-question-sign">{}</span>
                          </OverlayTrigger>
                        </div>
                      </div>
                      <div className="user-card-body">
                        <div className="row">
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-6">
                            <span><strong>{item.MarkType.name + ' ' + item.Category.label.toUpperCase()}</strong>{item.ceased && <span style={{color: 'red', marginLeft: 10}}> CESSATO</span>}</span>
                          </div>
                          <div style={{padding: 0}} className="col-md-6 text-right">
                            <span>ZON{item.MarkType.Areas.length > 1 ? 'E' : 'A'} <strong>{item.MarkType.Areas.map(item => item.code + ' ')}</strong></span>
                          </div>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <span>NUM. IDENTIFICATIVO: <strong>{item.id}</strong></span><br />
                            {item.fatherMark && <span>DERIVATO DA CONTRASSEGNO N.: <strong>{item.fatherMark}</strong></span>}
                          </div>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <span>TARG{item.Vehicles.length > 1 ? 'HE' : 'A'}: <strong>{item.Vehicles.map(item => item.plate_number + ' ')}</strong></span>
                          </div>
                        </div>
                      </div>
                      <div className="border-div">{}</div>
                      <div className="user-card-footer">
                        <div className="row">
                          <div style={{padding: 0, marginBottom: 5, marginTop: 5}} className="col-md-12">
                            {this.props.user.marks && <span>EMESSO IL: <strong>{moment(item.issudeDate).format('L')}</strong></span>}
                          </div>
                        </div>

                        {(item.status === 'PENDING_EDITABLE') && (
                          <div className="row">
                            <div className="col-md-6 col-btn-display">
                              <NavLink to={`/user-area/marks/edit/${item.id}`} className="btn-download-user">
                                MODIFICA
                              </NavLink>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>}
                  </div>)
                }) : null}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-md-offset-1 col-information-user hidden-xs hidden-sm">
          <div className="information-container">
            <div style={{marginLeft: 30}}>
              <div style={{marginTop: 15, marginBottom: 10}}>
                <TextUser bold>CONTRASSEGNI</TextUser>
                <TextUser>
                  In questa sezione puoi richiedere i contrassegni disponibili per la tua categoria utente.<br /><br />
                  <span style={{color: '#eb232f'}}><strong>Attenzione! </strong>Al momento tutte le funzionalità riguardanti i contrassegni sono disabilitate e non cliccabili.</span>
                </TextUser>
              </div>
            </div>
          </div>
        </div>
      </div>)
  }

  isUserBelongsToCategory (categoryId) {
    if (!this.props.user.categories) {
      return false
    }

    let filtered = this.props.user.categories.filter(item => {
      return item.id === categoryId
    })

    return filtered.length > 0
  }
}



// WEBPACK FOOTER //
// ./src/containers/UserArea/Mark/UserAreaMarks.js